module.exports = __webpack_public_path__ + "2aea15fc6f1ff1638030615bb54957c3.png";